import { buildTrialInfoOrUndefined } from './TrialInfo';
export const buildCurrentUserResponseOrNull = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (!data)
        return null;
    const result = {
        activePlanId: (_a = data.activePlanId) !== null && _a !== void 0 ? _a : '',
        activePlanGroup: (_b = data.activePlanGroup) !== null && _b !== void 0 ? _b : '',
        ownPlanId: (_c = data.ownPlanId) !== null && _c !== void 0 ? _c : '',
        ownPlanGroup: (_d = data.ownPlanGroup) !== null && _d !== void 0 ? _d : '',
        companyPurchasePlanId: (_e = data.companyPurchasePlanId) !== null && _e !== void 0 ? _e : '',
        companyPurchasePlanGroup: (_f = data.companyPurchasePlanGroup) !== null && _f !== void 0 ? _f : '',
        activeTrialInfo: buildTrialInfoOrUndefined(data.activeTrialInfo),
        lastTrialInfo: buildTrialInfoOrUndefined(data.lastTrialInfo),
        email: (_g = data.email) !== null && _g !== void 0 ? _g : '',
        firstName: (_h = data.firstName) !== null && _h !== void 0 ? _h : '',
        lastName: (_j = data.lastName) !== null && _j !== void 0 ? _j : '',
        name: (_k = data.name) !== null && _k !== void 0 ? _k : '',
        uid: (_l = data.uid) !== null && _l !== void 0 ? _l : '',
    };
    return result;
};
export const buildCurrentUserResponseOrEmpty = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (!data) {
        return {
            activePlanId: 'FREE_2016',
            activePlanGroup: 'Free',
            ownPlanId: 'FREE_2016',
            ownPlanGroup: 'Free',
            companyPurchasePlanId: 'FREE_2016',
            companyPurchasePlanGroup: 'Free',
            activeTrialInfo: undefined,
            lastTrialInfo: undefined,
            email: undefined,
            firstName: undefined,
            lastName: undefined,
            name: undefined,
            uid: undefined,
        };
    }
    return {
        activePlanId: (_a = data.activePlanId) !== null && _a !== void 0 ? _a : 'FREE_2016',
        activePlanGroup: (_b = data.activePlanGroup) !== null && _b !== void 0 ? _b : 'Free',
        ownPlanId: (_c = data.ownPlanId) !== null && _c !== void 0 ? _c : 'FREE_2016',
        ownPlanGroup: (_d = data.ownPlanGroup) !== null && _d !== void 0 ? _d : 'Free',
        companyPurchasePlanId: (_e = data.companyPurchasePlanId) !== null && _e !== void 0 ? _e : 'FREE_2016',
        companyPurchasePlanGroup: (_f = data.companyPurchasePlanGroup) !== null && _f !== void 0 ? _f : 'Free',
        activeTrialInfo: buildTrialInfoOrUndefined(data.activeTrialInfo),
        lastTrialInfo: buildTrialInfoOrUndefined(data.lastTrialInfo),
        email: (_g = data.email) !== null && _g !== void 0 ? _g : undefined,
        firstName: (_h = data.firstName) !== null && _h !== void 0 ? _h : undefined,
        lastName: (_j = data.lastName) !== null && _j !== void 0 ? _j : undefined,
        name: (_k = data.name) !== null && _k !== void 0 ? _k : undefined,
        uid: (_l = data.uid) !== null && _l !== void 0 ? _l : undefined,
    };
};
